// Copyright (c) Docugami, Inc. All rights reserved.**/

import styled from "styled-components";
import {
    PropsWithChildrenAndClassName,
    lgScreenMinWidth,
    mdScreenMinWidth,
    smScreenMinWidth,
    xlScreenMinWidth,
    xsScreenMinWidth
} from "./GridContainer";

const Item = styled.div<GridItemProps>`
    ${props => !!props.default.hide ? `display: none;` : ''}
    @media only screen and (min-width: ${xsScreenMinWidth}) {
        ${props => !!props.xs?.column ? `grid-column: ${props.xs.column};` : `grid-column: ${props.default.column};`}
        ${props => !!props.xs?.row ? `grid-row: ${props.xs.row};` : `grid-row: ${props.default.row};`}
        ${props => !!props.xs?.hide ? `display: none;` : ''}
    }
    @media only screen and (min-width: ${smScreenMinWidth}) {
        ${props => !!props.sm?.column ? `grid-column: ${props.sm.column};` : ''}
        ${props => !!props.sm?.row ? `grid-row: ${props.sm.row};` : ''}
        ${props => !!props.sm?.hide ? `display: none;` : ''}
    }
    @media only screen and (min-width: ${mdScreenMinWidth}) {
        ${props => !!props.md?.column ? `grid-column: ${props.md.column};` : ''}
        ${props => !!props.md?.row ? `grid-row: ${props.md.row};` : ''}
        ${props => !!props.md?.hide ? `display: none;` : ''}
    }
    @media only screen and (min-width: ${lgScreenMinWidth}) {
        ${props => !!props.lg?.column ? `grid-column: ${props.lg.column};` : ''}
        ${props => !!props.lg?.row ? `grid-row: ${props.lg.row};` : ''}
        ${props => !!props.lg?.hide ? `display: none;` : ''}
    }
    @media only screen and (min-width: ${xlScreenMinWidth}) {
        ${props => !!props.xl?.column ? `grid-column: ${props.xl.column};` : ''}
        ${props => !!props.xl?.row ? `grid-row: ${props.xl.row};` : ''}
        ${props => !!props.xl?.hide ? `display: none;` : ''}
    }
`;

// Can't use the below typing due to a bug in TS 4, but is fixed in TS 5. Use this when we migrate.
// type GridArea = `${number}` | `${number} / ${number}`;
type GridArea = string;

interface BreakpointProps {
    column: GridArea;
    row: GridArea;
    hide?: boolean;
}

interface GridItemProps {
    default: BreakpointProps;
    xs?: BreakpointProps;
    sm?: BreakpointProps;
    md?: BreakpointProps;
    lg?: BreakpointProps;
    xl?: BreakpointProps;
}

export const GridItem = (props: PropsWithChildrenAndClassName<GridItemProps>) => {
    return (
        <Item
            {...props}
        >
            {props.children}
        </Item>
    )
}
